import { useState } from "react";
import { useUserStore } from "../../stores/userStore";

export function TermsAcceptanceModal() {
  const profile = useUserStore((s) => s.profile);
  const acceptTerms = useUserStore((s) => (s as any).acceptTerms);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!profile) return null;
  if (profile.termsAcceptedAt) return null;

  const handleAccept = async () => {
    if (!acceptTerms) return;
    setSubmitting(true);
    setError(null);
    try {
      await acceptTerms();
    } catch (err) {
      setError("Something went wrong. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-cosmic-black/90 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-cosmic-surface border border-gold/30 rounded-xl max-w-md w-full p-6 shadow-2xl">
        <h2 className="font-display text-xl text-text-primary mb-2">
          We've added Terms of Service
        </h2>
        <p className="text-sm text-text-secondary mb-4 leading-relaxed">
          Before you continue, please review and accept our Terms & Privacy.
          They cover content protection, the entertainment-only nature of
          readings, and how we handle your data.
        </p>
        <div className="bg-cosmic-black/40 rounded-lg p-3 mb-4 max-h-40 overflow-y-auto text-xs text-text-secondary leading-relaxed space-y-2">
          <p className="font-medium text-text-primary">Protection of Creator Content</p>
          <p>Creator artwork and interpretations are owned by their creators and protected by copyright. You may not copy, redistribute, or use Creator Content to train AI models.</p>
          <p className="font-medium text-text-primary mt-2">For Entertainment Only</p>
          <p>Readings are for personal reflection and are not medical, legal, financial, or psychological advice. In an emergency, contact a qualified professional.</p>
        </div>
        <a
          href="/terms"
          target="_blank"
          rel="noreferrer"
          className="block text-center text-xs text-gold hover:text-gold-light mb-4 underline"
        >
          Read the full Terms & Privacy
        </a>
        {error && <p className="text-xs text-red-400 mb-3">{error}</p>}
        <button
          type="button"
          onClick={handleAccept}
          disabled={submitting}
          className="w-full bg-gold/20 hover:bg-gold/30 disabled:opacity-50 text-gold rounded-lg py-2.5 font-body tracking-wider uppercase text-sm transition-colors"
        >
          {submitting ? "Saving..." : "I agree"}
        </button>
      </div>
    </div>
  );
}
